import * as fromSubmissionsPage from './submissions-page/submissions-page.reducer';
import * as fromProductsPage from './products-page/products-page.reducer';
import { InjectionToken } from '@angular/core';
import { Action, ActionReducer, ActionReducerMap, MetaReducer, createFeatureSelector } from '@ngrx/store';
import { environment } from 'apps/scip-ui/src/environments/environment';

export interface State {
  [fromSubmissionsPage.SUBMISSIONS_PAGE_FEATURE_KEY]: fromSubmissionsPage.State;
  [fromProductsPage.PRODUCTS_PAGE_FEATURE_KEY]: fromProductsPage.State;
}

export const ROOT_STATE = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers token', {
  factory: () => ({
    [fromSubmissionsPage.SUBMISSIONS_PAGE_FEATURE_KEY]: fromSubmissionsPage.submissionsPageReducer,
    [fromProductsPage.PRODUCTS_PAGE_FEATURE_KEY]: fromProductsPage.productsPageReducer
  })
});

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return (state, action) => {
    const result = reducer(state, action);
    if (!action.type.includes('Notifications')) {
      console.groupCollapsed(action.type);
      console.log('prev state', state);
      console.log('action', action);
      console.log('next state', result);
      console.groupEnd();
    }

    return result;
  };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<State>[] = !environment.production ? [logger] : [];

export const selectSubmissionsPageState = createFeatureSelector<fromSubmissionsPage.State>(fromSubmissionsPage.SUBMISSIONS_PAGE_FEATURE_KEY);

export const selectProductsPageState = createFeatureSelector<fromProductsPage.State>(fromProductsPage.PRODUCTS_PAGE_FEATURE_KEY);
